export const FEATURE_CARD_STATE = {
  VIEW: "VIEW",
  EDIT: "EDIT",
}

export const GEOMETRY_TYPES = {
  LINE_STRING: "LineString",
  POINT: "Point",
  POLYGON: "Polygon",
}

export const FIELD_CONTENT_TYPES = {
  KML: "application/vnd.google-earth.kml+xml",
  X_ESRI_SHAPE: "application/x-esri-shape",
  GEOJSON: "application/geo+json",
}

export const FIELD_CONTENT_TYPES_DETAILS = [
  {
    text: "KML",
    value: FIELD_CONTENT_TYPES.KML,
  },
  {
    text: "Shapefile (Zip contendo um .shx, .shp e .dbf)",
    value: FIELD_CONTENT_TYPES.X_ESRI_SHAPE,
  },
  {
    text: "GeoJSON",
    value: FIELD_CONTENT_TYPES.GEOJSON,
  }
]
